import React from 'react';

import withPageComponents from '../../../page/components/with-page-components';
import ProductPriceV2 from '../../../product/components/product-price/product-price-v2';
import IntraDayDeals from '../../../product/components/deals';
import AddOnPrice from '../../../product/components/product-configurations/addon-price';
import LoyaltyBadge from '../../../product/components/loyalty-badge-v2';
import ProductCTA from '../../../product/components/purchase-button-v2';
import ProductStatusBadge from '../../../product/components/product-status-badge';
import CompareCheckbox from '../../../compare/components/compare-checkbox';
import PaypalBanner from '../../components/pdp-paypal-banner';

import FacebookChatbot from './facebook-chatbot';
import { CompatibleProductsLink } from '../compatible-products';
import { Helpers } from '../../../core/src/helpers';
import './cart-section.less';

const cartSection = ({ product }) => {
    if (product) {
        const { loyalty_multiplier = '0', plcode } = product.attributes || {};
        const showPaypalBanner = Helpers.isProductPC(product) && product.isSmb !== 'Yes';

        return (
            <div id="addtocart" className={'pdp-cart-section'}>
                <CompatibleProductsLink />
                <IntraDayDeals itemId={product.itemId}>
                    {dealProps => {
                        const { isActive, productDeals } = dealProps;
                        const deal = isActive ? productDeals.activeDeal : null;
                        return (
                            <AddOnPrice sku={product.sku}>
                                {({ addOnPrice }) => {
                                    return (
                                        <ProductPriceV2
                                            product={product}
                                            deal={deal}
                                            displayDifference={true}
                                            addOnPrice={addOnPrice}
                                            style={'left'}
                                        />
                                    );
                                }}
                            </AddOnPrice>
                        );
                    }}
                </IntraDayDeals>
                <LoyaltyBadge multiplier={loyalty_multiplier} type={'productCard'} color="purple" />
                <ProductCTA
                    id="pdpAddToCartBtn"
                    product={product}
                    enableAddToQuote={true}
                    enableCTOAddToCart={true}
                    templateKey="pdp"
                />
                <ProductStatusBadge product={product} displayShipMessage={true} size="large" />
                {showPaypalBanner && <PaypalBanner product={product} />}
                <CompareCheckbox product={product} btnText={'Add to compare'} selectedText={'Selected to compare'} />
                <span className="sku">{product.sku}</span>
                <FacebookChatbot plcode={plcode} />
            </div>
        );
    }
    return null;
};

cartSection.whyDidYouRender = true;

export default withPageComponents(cartSection, { components: ['product'] });
